/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetYourProfileQueryResponse,
  GetYourProfile401,
} from "../types/GetYourProfile.ts"
import { getYourProfileQueryResponseSchema } from "../zod/getYourProfileSchema.ts"

function getGetYourProfileUrl() {
  const res = { method: "GET", url: `/me/profile` as const }
  return res
}

/**
 * @summary Get your profile
 * {@link /me/profile}
 */
export async function getYourProfile(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetYourProfileQueryResponse,
    ResponseErrorConfig<GetYourProfile401>,
    unknown
  >({
    method: "GET",
    url: getGetYourProfileUrl().url.toString(),
    ...requestConfig,
  })
  return getYourProfileQueryResponseSchema.parse(res.data)
}
